import { reportNative, reportPageNative, jsNavigationDelegate } from '@/utils/bridge';
/**
 *
 * 上报方法基于3.0.0+
 */

/**
 * 进入页面时上报（实际为离开页面时,终端上报）
 * @param {Object} data
 *  - module 页面所属模块
 *  - page_name 页面名称
 */
export function reportPage(data) {
  reportPageNative(data);
}

/**
 * 按钮点击上报
 * @param {Object} data
 *  - page_name	页面名称
 *  - button_name 按钮名称
 */
export function reportClick(data) {
  reportNative({
    event_id: '10012',
    attributes: data,
  });
}

/**
 * 弹窗弹出上报
 * @param {Object} data
 *  - page_name	页面名称
 *  - pop_name	弹窗名称
 */
export function reportPop(data) {
  reportNative({
    event_id: '10013',
    attributes: data,
  });
}

/**
 * 弹窗点击上报
 * @param {Object} data
 *  - page_name	页面名称
 *  - pop_name	弹窗名称
 *  - button_name 按钮名称
 */
export function reportPopClick(data) {
  reportNative({
    event_id: '10014',
    attributes: data,
  });
}

/**
 * 曝光事件
 * @param {Object} data
 * @param {string} data.module  页面模块
 * @param {string} data.page_name  页面名称
 * @param {string} data.component  曝光组件名称
 */
export function reportExposure(data) {
  reportNative({
    event_id: '10011',
    attributes: data,
  });
}

/**
 * 其他上报事件
 * @param {string} event_id 事件id
 * @param {Object} data 上报属性
 */
export function reportEvent(event_id, data) {
  reportNative({
    event_id,
    attributes: data,
  });
}

/**
 * 离开页面时上报（因单页应用路由变化，终端感知不到，故主动通知）
 * @param {String} url 即将进入的页面链接
 */
export function reportDelegate(url) {
  jsNavigationDelegate({
    url,
  });
}
